import { render, staticRenderFns } from "./tenant_config_shell.vue?vue&type=template&id=6899a601&scoped=true&"
import script from "./tenant_config_shell.vue?vue&type=script&lang=js&"
export * from "./tenant_config_shell.vue?vue&type=script&lang=js&"
import style0 from "./tenant_config_shell.vue?vue&type=style&index=0&id=6899a601&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6899a601",
  null
  
)

export default component.exports